import React from 'react';
import { ModalContent } from 'fronton-react';
import { ModalHeader, Typography } from 'common/components';
import {
  newKitchenUtpSectionModalContent,
  newKitchenUtpSectionModalText,
} from '../../new-kitchen-utp-section-styles';

export const Quality: React.FC = () => (
  <>
    <ModalHeader title="Проверяем качество вручную" />
    <ModalContent className={newKitchenUtpSectionModalContent}>
      <Typography className={newKitchenUtpSectionModalText} variant="m" size="body_long" adaptive={false}>
        Собственные конструкторские разработки, 3-х ступенчатая оценка образцов, потребительские тесты,
        испытания во&nbsp;внутренней и&nbsp;внешней лаборатории, создание упаковки, индустриализация
        поставщиков.
      </Typography>
      <Typography variant="m" size="body_long" adaptive={false}>
        Наша команда не&nbsp;только проектирует уникальные решения, но&nbsp;и&nbsp;следит за&nbsp;строгим
        соблюдением стандартов качества. Мы&nbsp;проверяем каждое изделие вручную&nbsp;&mdash; тестируем
        поверхности и&nbsp;фурнитуру, выявляем возможные дефекты и&nbsp;обеспечиваем безупречность продукции.
        Это ещё одна гарантия, что наши кухни прослужат вам долго.
      </Typography>
    </ModalContent>
  </>
);
